import { render, staticRenderFns } from "./MyLeaveCredits.vue?vue&type=template&id=2b2d4c93&scoped=true"
import script from "./MyLeaveCredits.vue?vue&type=script&lang=js"
export * from "./MyLeaveCredits.vue?vue&type=script&lang=js"
import style0 from "./MyLeaveCredits.vue?vue&type=style&index=0&id=2b2d4c93&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d4c93",
  null
  
)

export default component.exports